module.exports = __webpack_public_path__ + "static/media/holiday_back.fbf29b69.png";